module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Login', {
    ref: "login",
    on: {
      "login": _vm.login
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfdea474"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyPageLogout.vue
// module id = 1031
// module chunks = 0